import {getFilteredPlaces} from '../../../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {TicketsListOwnProps, TicketsListRuntimeProps} from './interfaces'
import {TicketsList as Presentation} from './tickets-list'

const mapRuntime = ({state, actions: {clickPlace, resetFilters}}: DetailsPageAppProps): TicketsListRuntimeProps => ({
  places: getFilteredPlaces(state),
  resetFilters,
  clickPlace,
})

export const TicketsList = connect<TicketsListOwnProps, TicketsListRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
